import { useEffect, useState } from 'react';
import { requestJson } from './api.js';
import { normalizeEntitlements } from './normalize.js';

// No shared entitlement cache: old requests and old tokens cannot grant a slot.
export function useModules(token) {
  const scope = `${window.location.origin}:${token || ''}`;
  const [state, setState] = useState({ scope: null, items: [] });
  useEffect(() => {
    let active = true;
    setState({ scope, items: [] });
    if (token) {
      requestJson('/modules', { token }).then((payload) => {
        if (active) setState({ scope, items: normalizeEntitlements(payload) });
      }).catch(() => {
        if (active) setState({ scope, items: [] });
      });
    }
    return () => { active = false; };
  }, [scope, token]);
  return state.scope === scope && token ? state.items : [];
}
